import React from "react";

function SwapIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      fill="none"
      viewBox="0 0 17 18"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1.104 13.595H13.21M4.745 17.22l-3.641-3.625 3.641-3.624M15.62 4.77H3.517M11.98 1.146L15.62 4.77 11.98 8.395"
      ></path>
    </svg>
  );
}

export default SwapIcon;
